// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Buhta_conf__Config from "../../../../../packages/conf/lib/Config.js";
import * as Buhta_core__Auth from "../../../../../packages/core/lib/Auth.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import EyeClosedSvg from "static/icons/eye-closed.svg";
import EyeOpenedSvg from "static/icons/eye-opened.svg";

function RegisterIdentityForm(Props) {
  let payload = Props.payload;
  Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const match = React.useState(function () {
        
      });
  const setToast = match[1];
  const match$1 = React.useState(function () {
        return true;
      });
  const setPasswordHidden = match$1[1];
  const passwordHidden = match$1[0];
  const match$2 = React.useState(function () {
        return "";
      });
  const setEmail = match$2[1];
  const match$3 = React.useState(function () {
        return "";
      });
  const setPhone = match$3[1];
  const phone = match$3[0];
  const match$4 = React.useState(function () {
        return "";
      });
  const setGivenName = match$4[1];
  const match$5 = React.useState(function () {
        return "";
      });
  const setFamilyName = match$5[1];
  const match$6 = React.useState(function () {
        return "";
      });
  const setPassword = match$6[1];
  const match$7 = React.useState(function () {
        return [];
      });
  const setClosures = match$7[1];
  const closures = match$7[0];
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const env = cfg.app_env;
  const errors = payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthLoginPayload") ? payload.VAL.errors : /* [] */0;
  React.useEffect((function () {
          Curry._1(setClosures, (function (param) {
                  return Stdlib__Array.init(Stdlib__List.length(errors), (function (param) {
                                return false;
                              }));
                }));
        }), [errors]);
  const initialFocusRef = React.useRef(null);
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthLoginPayload")) {
    const payload$1 = payload.VAL;
    const __x = payload$1.errors;
    const __x$1 = payload$1.messages;
    tmp = JsxRuntime.jsxs(React.Fragment, {
          children: [
            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, error) {
                        const Key = "error-" + String(index);
                        return JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-4 text-whtie",
                                                  children: error
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx("img", {
                                                        src: StaticAsset.src("/static/icons/close-circle-white.svg")
                                                      }),
                                                  className: "border-l border-white-24 ml-3 p-2",
                                                  onClick: (function (param) {
                                                      Curry._1(setClosures, (function (param) {
                                                              return Stdlib__Array.mapi((function (i, param) {
                                                                            return i === index;
                                                                          }), closures);
                                                            }));
                                                    })
                                                })
                                          ],
                                          className: Cn.fromList({
                                                hd: "bg-alert border border-alert-16 rounded flex items-center",
                                                tl: {
                                                  hd: Cn.on("hidden", closures.length !== 0 && Caml_array.get(closures, index)),
                                                  tl: /* [] */0
                                                }
                                              })
                                        }),
                                    className: "fixed z-10 w-screen left-0 top-32 flex justify-center"
                                  }, Key);
                      }))),
            JsxRuntime.jsx(Buhta_cabinet__Box.make, {
                  title: "Регистрация",
                  className: "relative",
                  children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                        onSubmit: (function (param) {
                            
                          }),
                        initialFocusRef: initialFocusRef,
                        action: payload$1.action,
                        method_: "POST",
                        className: "mt-8",
                        children: [
                          JsxRuntime.jsx("input", {
                                name: "csrf_token",
                                type: "hidden",
                                value: payload$1.csrfToken
                              }),
                          JsxRuntime.jsx("input", {
                                name: "method",
                                type: "hidden",
                                value: "password"
                              }),
                          Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x$1, (function (index, msg) {
                                      const Key = "error-" + String(index);
                                      return JsxRuntime.jsx("span", {
                                                  children: msg,
                                                  className: "mt-2 text-asphalt"
                                                }, Key);
                                    }))),
                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                label: "Email",
                                type_: "email",
                                name: "traits.email",
                                required: true,
                                onChange: (function (value) {
                                    Curry._1(setEmail, (function (param) {
                                            return Stdlib__String.trim(value);
                                          }));
                                  }),
                                autoComplete: "off",
                                inputRef: initialFocusRef,
                                value: match$2[0]
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Фамилия",
                                        type_: "text",
                                        name: "traits.last_name",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setFamilyName, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        autoComplete: "off",
                                        value: match$5[0]
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Имя",
                                        type_: "text",
                                        name: "traits.first_name",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setGivenName, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        autoComplete: "off",
                                        className: "ml-4",
                                        value: match$4[0]
                                      })
                                ],
                                className: "mt-4 flex"
                              }),
                          JsxRuntime.jsx("input", {
                                name: "traits.phone",
                                type: "hidden",
                                value: Formating.formatPhone(phone)
                              }),
                          JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                                value: Formating.formatPhone(phone),
                                onChange: (function (value) {
                                    Curry._1(setPhone, (function (param) {
                                            return value;
                                          }));
                                  }),
                                required: true,
                                className: "mt-4"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Пароль",
                                        type_: passwordHidden ? "password" : "text",
                                        name: "password",
                                        required: true,
                                        onChange: Curry.__1(setPassword),
                                        autoComplete: "off",
                                        className: "mt-4",
                                        value: match$6[0]
                                      }),
                                  JsxRuntime.jsx("button", {
                                        children: passwordHidden ? JsxRuntime.jsx(EyeClosedSvg, {}) : JsxRuntime.jsx(EyeOpenedSvg, {}),
                                        className: "absolute right-4 top-5",
                                        tabIndex: -1,
                                        type: "button",
                                        onClick: (function (param) {
                                            Curry._1(setPasswordHidden, (function (param) {
                                                    return !passwordHidden;
                                                  }));
                                          })
                                      })
                                ],
                                className: "relative"
                              }),
                          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                kind: "primary",
                                type_: "submit",
                                className: "mt-6",
                                isWide: true,
                                children: "Зарегистрироваться"
                              }),
                          JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                className: "mt-4 text-asphalt",
                                children: [
                                  "Нажимая, вы соглашаетесь с ",
                                  JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                                        className: "text-links",
                                        children: JsxRuntime.jsx("a", {
                                              children: "пользовательским соглашением",
                                              className: "link",
                                              href: "/kz/ru/legal/agreement",
                                              target: "_blank"
                                            })
                                      }),
                                  " и со ",
                                  JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                                        className: "text-links",
                                        children: JsxRuntime.jsx("a", {
                                              children: "сбором, обработкой персональных данных",
                                              className: "link",
                                              href: "/kz/ru/legal/consent",
                                              target: "_blank"
                                            })
                                      })
                                ]
                              }),
                          JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                className: "animate-fadeIn mt-6 text-gray-medium",
                                children: [
                                  "Есть аккаунт? ",
                                  JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                                        className: "text-links",
                                        children: JsxRuntime.jsx("a", {
                                              children: "Войти",
                                              className: "link",
                                              href: env === "production" ? "https://id.buhta.com/login" : "https://id.sandbox.buhta.com/login"
                                            })
                                      })
                                ]
                              })
                        ]
                      })
                })
          ]
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "No csrf token provided"
        });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
              toast: match[0],
              onExpired: (function (param) {
                  Curry._1(setToast, (function (param) {
                          
                        }));
                }),
              children: tmp
            });
}

const make = RegisterIdentityForm;

export {
  make ,
}
/* Buhta_cabinet__Box Not a pure module */
